import React, { Component } from "react";
import BreadcrumbCustomer from "../breadcrumb";
import {  Form, Input, Button, Divider, message} from 'antd';
import {dbFields}  from '../../model/customs/column';
import { editCustom, getCustom } from "../../model/customs/requests";
import { route } from "../../routes/routes";
export const layout = {
    labelCol: {
      span: 6,
    },
    wrapperCol: {
      span: 14,
    },
};

export const tailLayout = {
    wrapperCol: {
      offset: 8,
      span: 16,
    },
};


class CustomApp extends Component {
    formRef = React.createRef();
    constructor(props) {
        super(props);
        this.state = {
            data: {}
        }
    };
    componentDidMount(){
        let id  = this.props.match.params.id;
        getCustom({id:id}).then(res=>{
            if(res.data.code === 200){
                let data = res.data.data
                this.setState({
                    data:data
                })
                this.formRef.current.setFieldsValue(data);
            }else{
                message.error(res.data.msg)
            }
        }).catch(err=>{
            message.error(err)
        })
    }
    
    handlerSubmit =()=>{
        let id  = parseInt(this.props.match.params.id);
        let  name = this.formRef.current.getFieldValue("name");
        let  desc = this.formRef.current.getFieldValue("desc");
        let app_name1 = this.formRef.current.getFieldValue(dbFields.app_name1.key);
        let app_name2 = this.formRef.current.getFieldValue(dbFields.app_name2.key);
        let app_url1 = this.formRef.current.getFieldValue(dbFields.app_url1.key);
        let app_url2 = this.formRef.current.getFieldValue(dbFields.app_url2.key);
        editCustom({id:id,name:name,desc:desc,app1_name:app_name1,appmanifest1:app_url1,app2_name:app_name2,appmanifest2:app_url2}).then(res=>{
            if (res.data.code === 200){
                message.success("app setting successful ")
                setTimeout(()=>{
                    this.props.history.push(route.customs.index)
                },1000)
             
            }else{
                message.error(res.data.msg)
            }
        }).catch(err=>{
            message.error(err)
        })
    }

    //todo edit the customs name ,
    render(){
        const {data} = this.state
        return (
            <>
              <BreadcrumbCustomer first='Custom' second='AppSetting' />
                <Divider />
                <Form
                    ref={this.formRef}
                    onFinish={this.handlerSubmit}
                    {...layout}
                    initialValues={{
                       name:data.name,
                       desc:data.desc,
                       app1_name:data.app1_name,
                       app2_name:data.app2_name,
                       appmanifest1:data.appmanifest1,
                       appmanifest12:data.appmanifest2
                    }}
                    >
                    <Form.Item
                        name="name"
                        label="Custom Name"
                    
                    >
                        <Input  disabled={true} />
                    </Form.Item>
                     <Form.Item
                        name= {'desc'}
                        label={'Description'}
                    
                     >
                        <Input.TextArea disabled={true} />
                    </Form.Item>
                    <Form.Item
                        name= {dbFields.app_name1.key}
                        label={dbFields.app_name1.title}
                    
                    >
                        <Input />
                     </Form.Item>
                        <Form.Item
                            name= {dbFields.app_url1.key}
                            label={dbFields.app_url1.title}
                    
                        >
                            <Input />
                        </Form.Item>
                        <Form.Item
                            name= {dbFields.app_name2.key}
                            label={dbFields.app_name2.title}
                    
                        >
                            <Input />
                        </Form.Item>
                        <Form.Item
                            name= {dbFields.app_url2.key}
                            label={dbFields.app_url2.title}
                    
                        >
                            <Input />
                        </Form.Item>

                        <Form.Item
                            wrapperCol={{
                                span: 12,
                                offset: 6,
                              }}
                        >
                            <Button 
                             style={{background: "#851dd6",color:"white" }}
                            type="primary" htmlType="submit">
                                Submit
                            </Button>
                        </Form.Item>    

                </Form>    
            
            </>

        )
    }
}

export default CustomApp;